import React from 'react';

import s from './AnimatedLogo.module.scss';
import getAssetLink from '../../../../util/getAssetLink';

const animationStates = [
  // {
  //   code: 'A',
  //   logoClass: s.logoAImg,
  //   duration: 10000000,
  // },
  {
    code: 'Logo',
    duration: 3000,
  },
  {
    code: 'R',
    logoClass: s.logoRImg,
    duration: 1000,
  },
  {
    code: 'A',
    logoClass: s.logoAImg,
    duration: 1000,
  },
  {
    code: 'S',
    logoClass: s.logoSImg,
    duration: 1000,
  },
  {
    code: 'C',
    logoClass: s.logoCImg,
    duration: 1000,
  },
  {
    code: 'E',
    logoClass: s.logoEImg,
    duration: 1000,
  },
  {
    code: 'I',
    logoClass: s.logoIImg,
    duration: 1000,
  },
];
const transitionTime = 1000;

class AnimatedLogo extends React.Component {
  // eslint-disable-next-line react/state-in-constructor
  state: any;

  animationTimeout: any = null;

  constructor(props: any) {
    super(props);

    this.state = {
      animationStateIndex: 0,
    };

    this.setupAnimationTimeout = this.setupAnimationTimeout.bind(this);
    this.clearAllTimers = this.clearAllTimers.bind(this);
  }

  componentDidMount(): void {
    this.setupAnimationTimeout(
      animationStates[this.state.animationStateIndex].duration,
    );
  }

  componentWillUnmount(): void {
    this.clearAllTimers();
  }

  setupAnimationTimeout(duration: number) {
    clearTimeout(this.animationTimeout);

    this.animationTimeout = setTimeout(() => {
      const nextAnimationStateIndex =
        (this.state.animationStateIndex + 1) % animationStates.length; // eslint-disable-line react/no-access-state-in-setstate
      const nextAnimationState = animationStates[nextAnimationStateIndex];

      this.setState({ animationStateIndex: nextAnimationStateIndex });

      this.setupAnimationTimeout(transitionTime + nextAnimationState.duration);
    }, duration);
  }

  clearAllTimers() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
    }
  }

  render() {
    const { animationStateIndex } = this.state;
    const animationState = animationStates[animationStateIndex];
    const prevAnimationState =
      animationStates[
        (animationStateIndex - 1 + animationStates.length) %
          animationStates.length
      ];

    return (
      <div className={s.animatedLogo}>
        <img
          className={`${s.logoImg} ${animationState.logoClass || ''}`}
          src={getAssetLink('startpage/animated_logo/logo.png')}
          alt="Jopsy Logo"
        />
        <img
          className={`${s.riasecImg} ${s.rImg} ${animationState.code === 'R' ? s.show : ''} ${prevAnimationState.code === 'R' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/macher.png')}
          alt=""
        />
        <img
          className={`${s.riasecImg} ${s.iImg} ${animationState.code === 'I' ? s.show : ''} ${prevAnimationState.code === 'I' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/denker.png')}
          alt=""
        />
        <img
          className={`${s.riasecImg} ${s.aImg} ${animationState.code === 'A' ? s.show : ''} ${prevAnimationState.code === 'A' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/gestalter.png')}
          alt=""
        />
        <img
          className={`${s.riasecImg} ${s.sImg} ${animationState.code === 'S' ? s.show : ''} ${prevAnimationState.code === 'S' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/soziale.png')}
          alt=""
        />
        <img
          className={`${s.riasecImg} ${s.eImg} ${animationState.code === 'E' ? s.show : ''} ${prevAnimationState.code === 'E' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/ueberzeuger.png')}
          alt=""
        />
        <img
          className={`${s.riasecImg} ${s.cImg} ${animationState.code === 'C' ? s.show : ''} ${prevAnimationState.code === 'C' ? s.hide : ''}`}
          src={getAssetLink('startpage/animated_logo/organisierte.png')}
          alt=""
        />
      </div>
    );
  }
}

export default AnimatedLogo;
